// components/discovery/ScoreCriteriaManager.jsx
import React, { useState } from 'react';
import { Plus, X, Download } from 'lucide-react';

const ScoreCriteriaManager = ({ title, type, currentScores, availableCriteria, onUpdate, onRequestData, isLoading }) => {
    const [isAdding, setIsAdding] = useState(false);
    const [newCriterion, setNewCriterion] = useState('');

    const handleAdd = () => {
        if (newCriterion) {
            onUpdate({
                ...currentScores,
                [newCriterion]: 5 // Default score
            });
            setNewCriterion('');
            setIsAdding(false);
        }
    };

    const handleRemove = (criterion) => {
        const newScores = { ...currentScores };
        delete newScores[criterion];
        onUpdate(newScores);
    };

    // Filter out criteria already in use
    const availableOptions = availableCriteria.filter(
        criterion => !currentScores.hasOwnProperty(criterion)
    );

    return (
        <div className="border rounded p-2 mt-2">
            <div className="flex justify-between items-center mb-2">
                <span className="text-xs font-medium text-gray-700">{title}</span>
                <div className="flex gap-2">
                    {onRequestData && (
                        <button
                            onClick={onRequestData}
                            disabled={isLoading}
                            className="text-xs text-green-600 hover:text-green-700 disabled:opacity-50 flex items-center gap-1"
                        >
                            <Download className="w-3 h-3" />
                            {isLoading ? 'Loading...' : `Load ${type}s`}
                        </button>
                    )}
                    {!isAdding && availableCriteria.length > 0 && (
                        <button
                            onClick={() => setIsAdding(true)}
                            className="text-xs text-blue-600 hover:text-blue-700"
                        >
                            Add {type}
                        </button>
                    )}
                </div>
            </div>

            {isAdding && (
                <div className="flex gap-2 mb-2">
                    <select
                        value={newCriterion}
                        onChange={(e) => setNewCriterion(e.target.value)}
                        className="text-xs p-1 border rounded flex-1"
                    >
                        <option value="">Select {type}</option>
                        {availableOptions.map(criterion => (
                            <option key={criterion} value={criterion}>
                                {criterion}
                            </option>
                        ))}
                    </select>
                    <button
                        onClick={handleAdd}
                        className="px-2 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                        Add
                    </button>
                    <button
                        onClick={() => setIsAdding(false)}
                        className="px-2 py-1 text-xs bg-gray-200 rounded hover:bg-gray-300"
                    >
                        Cancel
                    </button>
                </div>
            )}

            {Object.entries(currentScores).map(([criterion, score]) => (
                <div key={criterion} className="flex items-center gap-2 mb-2">
                    <button
                        onClick={() => handleRemove(criterion)}
                        className="text-red-500 hover:text-red-600"
                    >
                        <X className="w-4 h-4" />
                    </button>
                    <span className="text-xs flex-1">{criterion}</span>
                    <input
                        type="range"
                        min="0"
                        max="10"
                        value={score}
                        onChange={(e) => onUpdate({
                            ...currentScores,
                            [criterion]: parseInt(e.target.value)
                        })}
                        className="flex-1"
                    />
                    <span className="text-xs w-8 text-right">{score}</span>
                </div>
            ))}
        </div>
    );
};

export default ScoreCriteriaManager;